import gql from "graphql-tag";
import xlsx from "xlsx/dist/xlsx.full.min.js";

function yesNo(value) {
    if (value === true) return "Yes";
    if (value === false) return "No";
    return "";
}

function num(value) {
    if (value === null || value === undefined || value === "") return "";
    return value;
}

function formatBuildingAge(openedOn) {
    if (!openedOn) return "";
    var parts = String(openedOn).substring(0, 10).split("-");
    if (parts.length !== 3) return "";
    var y = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10) - 1;
    var d = parseInt(parts[2], 10);
    if (isNaN(y) || isNaN(m) || isNaN(d)) return "";
    var opened = new Date(y, m, d);
    var now = new Date();
    var age = now.getFullYear() - opened.getFullYear();
    var md = now.getMonth() - opened.getMonth();
    if (md < 0 || (md === 0 && now.getDate() < opened.getDate())) age--;
    if (age < 0) age = 0;
    return age === 1 ? "1 year" : age + " years";
}

function pageInfoFields() {
    return `
        paginatorInfo {
            currentPage
            lastPage
            perPage
            total
            hasMorePages
        }
    `;
}

function listQuery(root, fields) {
    return gql`
        query FacilityExport_${root}($first: Int!, $page: Int!, $entity: String, $campus: String) {
            ${root}(first: $first, page: $page, entity: $entity, campus: $campus) {
                error
                message
                ${pageInfoFields()}
                data {
                    ${fields}
                }
            }
        }
    `;
}

var SHEETS = [
    {
        key: "BuildingOverview",
        sheetName: "Building Overview",
        root: "facilityBuildingOverviews",
        fields: "id location opened_on components floors_count",
        mapRow: function (item) {
            return {
                Location: item.location || "",
                "Building Age": formatBuildingAge(item.opened_on),
                Components: item.components || "",
                Floors: num(item.floors_count),
            };
        },
    },
    {
        key: "FacilityAreas",
        sheetName: "Campus Areas",
        root: "facilityAreas",
        fields:
            "id landscape_area main_building gym_building students_center_building unit",
        mapRow: function (item) {
            return {
                "Landscape Area": num(item.landscape_area),
                "Main Building": num(item.main_building),
                "Gym Building": num(item.gym_building),
                "Students Center Building": num(item.students_center_building),
                Unit: item.unit || "m²",
            };
        },
    },
    {
        key: "Classrooms",
        sheetName: "Classrooms",
        root: "facilityClassrooms",
        fields: "id title seating_type max_seats location remarks",
        mapRow: function (item) {
            return {
                Classroom: item.title || "",
                "Seating Type": item.seating_type || "",
                Capacity: num(item.max_seats),
                Location: item.location || "",
                Remarks: item.remarks || "",
            };
        },
    },
    {
        key: "Labs",
        sheetName: "Labs",
        root: "facilityLabs",
        fields: "id title description seating_type max_seats location remarks",
        mapRow: function (item) {
            return {
                Room: item.title || "",
                Description: item.description || "",
                Type: item.seating_type || "",
                Capacity: num(item.max_seats),
                Location: item.location || "",
                Remarks: item.remarks || "",
            };
        },
    },
    {
        key: "AcademicOffices",
        sheetName: "Academic Offices",
        root: "facilityAcademicOffices",
        fields:
            "id office_type room floor is_occupied stations_count room_type has_toilet has_meeting has_waiting has_assistance_office remarks",
        mapRow: function (item) {
            return {
                "Office Type": item.office_type || "",
                Room: item.room || "",
                Floor: item.floor || "",
                Occupied: yesNo(item.is_occupied),
                Stations: num(item.stations_count),
                "Room Type": item.room_type || "",
                Toilet: yesNo(item.has_toilet),
                Meeting: yesNo(item.has_meeting),
                Waiting: yesNo(item.has_waiting),
                "Assistance Office": yesNo(item.has_assistance_office),
                Remarks: item.remarks || "",
            };
        },
    },
    {
        key: "AdminOffices",
        sheetName: "Admin Offices",
        root: "facilityAdminOffices",
        fields:
            "id office_type room floor is_occupied stations_count room_type has_toilet has_meeting has_waiting has_assistance_office remarks",
        mapRow: function (item) {
            return {
                "Office Type": item.office_type || "",
                Room: item.room || "",
                Floor: item.floor || "",
                Occupied: yesNo(item.is_occupied),
                Stations: num(item.stations_count),
                "Room Type": item.room_type || "",
                Toilet: yesNo(item.has_toilet),
                Meeting: yesNo(item.has_meeting),
                Waiting: yesNo(item.has_waiting),
                "Assistance Office": yesNo(item.has_assistance_office),
                Remarks: item.remarks || "",
            };
        },
    },
    {
        key: "Auditorium",
        sheetName: "Auditorium",
        root: "facilityAuditoriums",
        fields: "id title room size location capacity has_sound_system remarks",
        mapRow: function (item) {
            return {
                Name: item.title || "",
                Room: item.room || "",
                Size: item.size || "",
                Location: item.location || "",
                Capacity: num(item.capacity),
                "Sound System": yesNo(item.has_sound_system),
                Remarks: item.remarks || "",
            };
        },
    },
    {
        key: "MeetingRooms",
        sheetName: "Meeting Rooms",
        root: "facilityMeetingRooms",
        fields: "id title room size capacity location remarks",
        mapRow: function (item) {
            return {
                Name: item.title || "",
                Room: item.room || "",
                Size: item.size || "",
                Capacity: num(item.capacity),
                Location: item.location || "",
                Remarks: item.remarks || "",
            };
        },
    },
    {
        key: "CarParking",
        sheetName: "Car Parking",
        compositeBlocks: true,
        sources: [
            {
                title: "Parking Areas",
                root: "facilityParkingAreas",
                fields:
                    "id parking_location parking_slots vip_parking determination has_car_charge inside_outside is_paid_parking shaded is_underground has_sensor remarks",
                mapRow: function (item) {
                    return {
                        "Parking Location": item.parking_location || "",
                        Slots: num(item.parking_slots),
                        VIP: num(item.vip_parking),
                        Determination: num(item.determination),
                        "Car Charge": yesNo(item.has_car_charge),
                        "Inside/Outside": item.inside_outside || "",
                        Paid: yesNo(item.is_paid_parking),
                        Shaded: item.shaded || "",
                        Underground: yesNo(item.is_underground),
                        Sensor: yesNo(item.has_sensor),
                        Remarks: item.remarks || "",
                    };
                },
            },
            {
                title: "Transport Services",
                root: "facilityParkingTransportServices",
                fields: "id service_name availability passenger_capacity remarks",
                mapRow: function (item) {
                    return {
                        Service: item.service_name || "",
                        Availability: item.availability || "",
                        "No. Passengers": item.passenger_capacity || "",
                        Remarks: item.remarks || "",
                    };
                },
            },
            {
                title: "Helipads",
                root: "facilityParkingHelipads",
                fields: "id service_name quantity location remarks",
                mapRow: function (item) {
                    return {
                        Service: item.service_name || "",
                        Quantity: num(item.quantity),
                        Location: item.location || "",
                        Remarks: item.remarks || "",
                    };
                },
            },
        ],
    },
    {
        key: "Gates",
        sheetName: "Gates",
        root: "facilityGates",
        fields:
            "id gate_name exit_entrance users barrier_availability automatic_manual is_shaded has_security_booth comments",
        mapRow: function (item) {
            return {
                "Gate Name": item.gate_name || "",
                "Exit/Entrance": item.exit_entrance || "",
                Users: item.users || "",
                "Barrier Availability": item.barrier_availability || "",
                "Automatic/Manual": item.automatic_manual || "",
                Shaded: yesNo(item.is_shaded),
                "Security Booth": yesNo(item.has_security_booth),
                Comments: item.comments || "",
            };
        },
    },
    {
        key: "Toilets",
        sheetName: "Toilets",
        root: "facilityToilets",
        fields:
            "id block toilets_room users floor cubicle_count has_determination wash_basin_count shower_room_count has_water_sensors remarks",
        mapRow: function (item) {
            return {
                Block: item.block || "",
                "Toilets Room": item.toilets_room || "",
                Users: item.users || "",
                Floor: item.floor || "",
                Cubicles: num(item.cubicle_count),
                Determination: yesNo(item.has_determination),
                "Wash Basins": num(item.wash_basin_count),
                "Shower Rooms": num(item.shower_room_count),
                "Water Sensors": yesNo(item.has_water_sensors),
                Remarks: item.remarks || "",
            };
        },
    },
    {
        key: "Stores",
        sheetName: "Stores",
        root: "facilityStores",
        fields: "id name room is_occupied comments",
        mapRow: function (item) {
            return {
                Name: item.name || "",
                Room: item.room || "",
                Occupied: yesNo(item.is_occupied),
                Comments: item.comments || "",
            };
        },
    },
    {
        key: "ServiceRooms",
        sheetName: "Service Rooms",
        root: "facilityServiceRooms",
        fields: "id name room comments",
        mapRow: function (item) {
            return {
                Name: item.name || "",
                Room: item.room || "",
                Comments: item.comments || "",
            };
        },
    },
    {
        key: "SportFacilities",
        sheetName: "Sport Facilities",
        root: "facilitySportFacilities",
        fields: "id name size capacity location warranty_contract is_indoor",
        mapRow: function (item) {
            return {
                Name: item.name || "",
                Size: item.size || "",
                Capacity: num(item.capacity),
                Location: item.location || "",
                "Warranty/Contract": item.warranty_contract || "",
                Indoor: yesNo(item.is_indoor),
            };
        },
    },
    {
        key: "Canteen",
        sheetName: "Canteen",
        root: "facilityCanteens",
        fields:
            "id name size capacity location has_furniture has_preparation_kitchen has_stores warranty_contract",
        mapRow: function (item) {
            return {
                Name: item.name || "",
                Size: item.size || "",
                Capacity: num(item.capacity),
                Location: item.location || "",
                Furniture: yesNo(item.has_furniture),
                "Prep Kitchen": yesNo(item.has_preparation_kitchen),
                Stores: yesNo(item.has_stores),
                "Warranty/Contract": item.warranty_contract || "",
            };
        },
    },
    {
        key: "Clinic",
        sheetName: "Clinic",
        root: "facilityClinics",
        fields:
            "id name room size staff_count location bed_count observation_room_count store_count medical_waste_room_count remarks",
        mapRow: function (item) {
            return {
                Name: item.name || "",
                Room: item.room || "",
                Size: item.size || "",
                "Staff Count": num(item.staff_count),
                Location: item.location || "",
                "Bed Count": num(item.bed_count),
                "Observation Rooms": num(item.observation_room_count),
                Stores: num(item.store_count),
                "Medical Waste Rooms": num(item.medical_waste_room_count),
                Remarks: item.remarks || "",
            };
        },
    },
    {
        key: "PrayerRoom",
        sheetName: "Prayer Room",
        root: "facilityPrayerRooms",
        fields: "id name room size capacity location has_ablution_room comments",
        mapRow: function (item) {
            return {
                Name: item.name || "",
                Room: item.room || "",
                Size: item.size || "",
                Capacity: num(item.capacity),
                Location: item.location || "",
                "Ablution Room": yesNo(item.has_ablution_room),
                Comments: item.comments || "",
            };
        },
    },
    {
        key: "PantriesKitchen",
        sheetName: "Pantries & Kitchen",
        root: "facilityPantries",
        fields: "id name room location is_used remarks",
        mapRow: function (item) {
            return {
                Name: item.name || "",
                Room: item.room || "",
                Location: item.location || "",
                "In Use": yesNo(item.is_used),
                Remarks: item.remarks || "",
            };
        },
    },
    {
        key: "VendingMachines",
        sheetName: "Vending Machines",
        root: "facilityVendingMachines",
        fields: "id name machine_type location comments",
        mapRow: function (item) {
            return {
                Name: item.name || "",
                Type: item.machine_type || "",
                Location: item.location || "",
                Comments: item.comments || "",
            };
        },
    },
    {
        key: "PalmAndTrees",
        sheetName: "Palm & Trees",
        root: "facilityPalmTrees",
        fields: "id area_name plant_type total_count",
        mapRow: function (item) {
            return {
                Area: item.area_name || "",
                Type: item.plant_type || "",
                Total: num(item.total_count),
            };
        },
    },
    {
        key: "SecurityCam",
        sheetName: "Security Camera",
        root: "facilitySecurityCameras",
        fields: "id area_name total_count",
        mapRow: function (item) {
            return {
                Area: item.area_name || "",
                Total: num(item.total_count),
            };
        },
    },
];

var queryCache = {};

function getQuery(root, fields) {
    var cacheKey = root + "|" + fields;
    if (!queryCache[cacheKey]) {
        queryCache[cacheKey] = listQuery(root, fields);
    }
    return queryCache[cacheKey];
}

async function fetchAllPages(apollo, root, fields, entity, campus) {
    var rows = [];
    var page = 1;
    var hasMore = true;
    var query = getQuery(root, fields);

    while (hasMore) {
        var response = await apollo.query({
            query: query,
            variables: {
                first: 500,
                page: page,
                entity: entity,
                campus: campus,
            },
            fetchPolicy: "network-only",
        });

        var payload =
            response && response.data && response.data[root]
                ? response.data[root]
                : null;

        if (!payload || payload.error) {
            throw new Error(
                (payload && payload.message) ||
                    "Failed to fetch " + root + " for export."
            );
        }

        var data = payload.data || [];
        if (data.length) {
            rows.push.apply(rows, data);
        }

        hasMore = !!(
            payload.paginatorInfo && payload.paginatorInfo.hasMorePages
        );
        page += 1;
        if (page > 100) break;
    }

    return rows;
}

function safeSheetName(name) {
    var cleaned = String(name || "Sheet")
        .replace(/[\\/?*[\]]/g, " ")
        .trim();
    if (!cleaned) cleaned = "Sheet";
    return cleaned.substring(0, 31);
}

function objectRowsToAoa(rows) {
    if (!rows || !rows.length) return [["No records"]];
    var headers = Object.keys(rows[0]);
    var aoa = [headers];
    for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var values = [];
        for (var h = 0; h < headers.length; h++) {
            var val = row[headers[h]];
            values.push(val === null || val === undefined ? "" : val);
        }
        aoa.push(values);
    }
    return aoa;
}

async function buildCompositeWorksheet(apollo, sheet, entity, campus) {
    var aoa = [];
    var totalRows = 0;

    for (var s = 0; s < sheet.sources.length; s++) {
        var source = sheet.sources[s];
        var sourceRows = await fetchAllPages(
            apollo,
            source.root,
            source.fields,
            entity,
            campus
        );
        var mapped = [];
        for (var r = 0; r < sourceRows.length; r++) {
            mapped.push(source.mapRow(sourceRows[r]));
        }
        totalRows += mapped.length;

        if (aoa.length > 0) {
            aoa.push([]);
        }
        aoa.push([source.title]);
        var block = objectRowsToAoa(mapped);
        for (var b = 0; b < block.length; b++) {
            aoa.push(block[b]);
        }
    }

    if (!aoa.length) {
        aoa = [["No records"]];
    }

    return {
        worksheet: xlsx.utils.aoa_to_sheet(aoa),
        rowCount: totalRows,
    };
}

export function getTotalSheetCount() {
    return SHEETS.length;
}

/**
 * Export all facility sections into one multi-sheet Excel workbook.
 * @param {object} apollo - Vue Apollo client (this.$apollo)
 * @param {string} entity
 * @param {string} campus
 * @param {function} [onProgress] - Optional callback: onProgress({ sheetIndex, sheetName, totalSheets, percent })
 * @returns {Promise<{ sheetCount: number, rowCount: number, fileName: string }>}
 */
export async function exportAllFacilitySections(apollo, entity, campus, onProgress) {
    var workbook = xlsx.utils.book_new();
    var sheetCount = 0;
    var rowCount = 0;
    var total = SHEETS.length;

    function reportProgress(sheetIndex, sheetName) {
        if (typeof onProgress === "function") {
            var percent = Math.round(((sheetIndex + 1) / total) * 100);
            onProgress({
                sheetIndex: sheetIndex,
                sheetName: sheetName,
                totalSheets: total,
                percent: percent,
            });
        }
    }

    for (var i = 0; i < SHEETS.length; i++) {
        var sheet = SHEETS[i];
        var worksheet = null;
        var mappedCount = 0;

        reportProgress(i, sheet.sheetName);

        if (sheet.compositeBlocks && sheet.sources) {
            var composite = await buildCompositeWorksheet(
                apollo,
                sheet,
                entity,
                campus
            );
            worksheet = composite.worksheet;
            mappedCount = composite.rowCount;
        } else {
            var mapped = [];
            var rawRows = await fetchAllPages(
                apollo,
                sheet.root,
                sheet.fields,
                entity,
                campus
            );
            for (var j = 0; j < rawRows.length; j++) {
                mapped.push(sheet.mapRow(rawRows[j]));
            }
            mappedCount = mapped.length;
            worksheet =
                mapped.length > 0
                    ? xlsx.utils.json_to_sheet(mapped)
                    : xlsx.utils.aoa_to_sheet([["No records"]]);
        }

        xlsx.utils.book_append_sheet(
            workbook,
            worksheet,
            safeSheetName(sheet.sheetName)
        );
        sheetCount += 1;
        rowCount += mappedCount;
    }

    var fileName = "ADPOLY_" + campus + "_Facility_All_Sections.xlsx";
    xlsx.writeFile(workbook, fileName);

    return {
        sheetCount: sheetCount,
        rowCount: rowCount,
        fileName: fileName,
    };
}
